if (!customElements.get('product-media-gallery')) {
  class ProductMediaGallery extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.scrollContainer = this.querySelector('.product-media-gallery__media');
      this.activeIndex = 0;
      this.lastIndex = this.scrollContainer.childElementCount - 1;
      this.scrollProgressBar = this.querySelector('.product-media-gallery__active-progress-bar');
      this.handleMQLChange = this.handleMQLChange.bind(this);
      this.handleClick = this.handleClick.bind(this);
      this.handleScroll = this.handleScroll.bind(this);
      this.handleScrollEnd = this.handleScrollEnd.bind(this);

      if (this.closest('product-info')) {
        this.mql = window.matchMedia("(width >= 990px)");
        this.handleMQLChange(this.mql);
        this.mql.addEventListener('change', this.handleMQLChange);
      }

      this.scrollProgressBar.style.width = `calc(100% / ${this.querySelectorAll('.product-media-gallery__media > *').length})`;

      this.classList.remove('opacity-0');

      this.scrollContainer.addEventListener('click', this.handleClick);
      this.scrollContainer.addEventListener('scroll', this.handleScroll);
      this.scrollContainer.addEventListener('scrollend', this.handleScrollEnd);
    }

    disconnectedCallback() {
      if (this.closest('product-info')) {
        this.mql.removeEventListener('change', this.handleMQLChange);
      }
      
      this.scrollContainer.removeEventListener('click', this.handleClick);
      this.scrollContainer.removeEventListener('scroll', this.handleScroll);
      this.scrollContainer.removeEventListener('scrollend', this.handleScrollEnd);
    }

    handleMQLChange(event) {
      if (event.matches) {
        this.style.height = `calc(100% - ${document.querySelector('.product-info__content-form').offsetHeight}px)`;
      } else {
        this.style.height = `calc(100svh - var(--header-height) - ${document.querySelector('.product-info__form').offsetHeight}px  - ${document.querySelector('.product-info__variant-selects').offsetHeight}px - ${document.querySelector('.product-info__header').offsetHeight}px)`;
      }
    }

    handleClick(event) {
      if (event.offsetX < this.offsetWidth / 2) {
        // clicking left side
        if (this.activeIndex > 0) {
          // if not at start
          this.activeIndex = this.activeIndex - 1;
        } else {
          // if at start
          this.activeIndex = this.lastIndex;
        }
      } else if (event.offsetX >= this.offsetWidth / 2) {
        // clicking right side
        if (this.activeIndex < this.lastIndex) {
          // if not at end
          this.activeIndex = this.activeIndex + 1;
        } else {
          // if at end
          this.activeIndex = 0;
        }
      }

      this.scrollContainer.scroll({
        top: 0,
        left: this.activeIndex * this.offsetWidth,
        behavior: "smooth",
      });
    }

    handleScroll() {
      this.scrollProgressBar.style.width = `${(this.scrollContainer.offsetWidth + this.scrollContainer.scrollLeft)/ (this.scrollContainer.offsetWidth * this.querySelectorAll('.product-media-gallery__media > *').length) * 100}%`;
    }

    handleScrollEnd() {
      this.activeIndex = this.scrollContainer.scrollLeft / this.scrollContainer.offsetWidth;
    }
  }
  
  customElements.define('product-media-gallery', ProductMediaGallery);
}
